import CryptoJS from 'crypto-js'


import router from '@/router';


// const origin = 'http://localhost:18000';

// const origin = 'http://192.168.1.8:18000';

// const origin = 'http://www.tianzhy.com';

// const origin = 'https://course.tianzhy.com';



// const appId = 'work-house-app';

const origin = config.origin;
const appId = config.appId;


const UUID = {
	cs: '012346789abcdef'.toUpperCase().split(''),
	get: function(n) {
		n = n || 32;
		var value = "";
		for (var i = 0; i < n; i++) {
			var index = Math.floor(Math.random() * this.cs.length);
			value += this.cs[index];
		}
		return value;
	}
};

function getLocalUuid() {
	let uuid = localStorage.getItem('uuid');
	if (!uuid) {
		uuid = UUID.get();
		localStorage.setItem('uuid', uuid);
	}
	return uuid;
}


export function makeSign() {

	const R = UUID.get();
	const T = Date.now() + '';
	const S = CryptoJS.MD5(`${R}:${T}:${R}:${T}`).toString(CryptoJS.enc.Hex);
	return {
		R,
		T,
		S
	}

}

export function makeHeaders() {
	return {
		'Invite-Code': localStorage.getItem('inviteCode') || localStorage.getItem('startInviteCode') || '',
		'Rts': localStorage.getItem('rts') || '',
		'user-id': localStorage.getItem('userId') || '',
		'token': localStorage.getItem('token') || '',
		'App-Id': appId,
		...makeSign(),
	}
}


function onSuccess(resp) {

}

export default function request({
	url,
	method,
	header,
	headers,
	data,
	success,
	fail,
	complete,
	loading,
}) {
	if (loading) {
		Loading.open();
	}
	reqwest({
		url: origin + url,
		method: method || 'post',
		headers: {
			'Uuid': getLocalUuid(),
			'Invite-Code': localStorage.getItem('inviteCode') || localStorage.getItem('startInviteCode') || '',
			'Rts': localStorage.getItem('rts') || '',
			'Content-Type': 'application/json; charset=utf-8',
			'user-id': localStorage.getItem('userId') || '',
			'token': localStorage.getItem('token') || '',
			...header,
			...headers,
			'App-Id': appId,
			...makeSign(),
		},
		data: data ? JSON.stringify(data) : data,
		success(resp) {
			console.log('request resp', resp)
			if (resp.success || resp.code == 0 || resp.code == 200) {
				success && success(resp);
			} else if (fail) {
				fail(resp);
			} else if (resp.code == 401) { // token过期
				Message.error('登录已过期，请重新登录')
				router.push('/login')
			} else {

				Message.error(resp.error || resp.msg || '服务异常')
			}
		},
		fail(err) {
			console.error(err)
			if (fail) {
				fail(err);
			} else {

				Message.error(JSON.stringify(err))
			}
		},
		complete() {
			if (loading) {
				Loading.close();
			}
			complete && complete()
		}
	})
}





export function uploadFile({
	url,
	file,
	name,
	header,
	headers,
	success,
	fail,
	complete,
	loading,
}) {
	if (loading) {
		uni.showLoading()
	}
	const formData = new FormData();
	formData.append('file', file);
	reqwest({
		url: origin + (url || '/api/file/upload/oss'),
		method: 'post',
		headers: {
			'Invite-Code': localStorage.getItem('inviteCode') || localStorage.getItem('startInviteCode') || '',
			'Rts': localStorage.getItem('rts') || '',
			'user-id': localStorage.getItem('userId') || '',
			'token': localStorage.getItem('token') || '',
			...header,
			...headers,
			'App-Id': appId,
			...makeSign(),
		},
		processData: false, // 重要：不处理数据
		contentType: false, // 重要：不设置Content-Type
		data: formData,
		success(resp) {
			console.log('request resp', resp)
			if (resp.success || resp.code == 0 || resp.code == 200) {
				success && success(resp);
			} else if (fail) {
				fail(resp);
			} else if (resp.code == 401) { // token过期
				Message.error('登录已过期，请重新登录')
				router.push('/login')
			} else {

				Message.error(resp.error || resp.msg || '服务异常')
			}
		},
		fail(err) {
			console.error(err)
			if (fail) {
				fail(err);
			} else {

				Message.error(JSON.stringify(err))
			}
		},
		complete() {
			if (loading) {
				Loading.close();
			}
			complete && complete()
		}
	});
}

request.origin = origin;
request.makeHeaders = makeHeaders